/**
 * @file utils.js
 * @description Collection of reusable functions, classes, or methods that do not fit into an exclusive use-case.
 */

/**
 * Formats a date string into a readable string with local timezone abbreviation.
 * Example output: "May 12 2026 3:45 PM (PDT)"
 * @param {string} dateString - The ISO date string to format.
 * @returns {string} The formatted date string with timezone.
 */
export function formatDateWithTimezone(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    let dateTime = `${months[date.getMonth()]} ${date.getDate().toString().padStart(2, '0')} ${date.getFullYear()}`;
    let hours = date.getHours();
    let dayTime = '';
    if (hours === 0) {
        hours = '12';
        dayTime = 'AM';
    } else if (hours === 12) {
        hours = '12';
        dayTime = 'PM';
    } else if (hours < 12) {
        hours = hours.toString();
        dayTime = 'AM';
    } else {
        hours = (hours - 12).toString();
        dayTime = 'PM';
    }
    let minutes = date.getMinutes().toString().padStart(2, '0');
    dateTime += ` ${hours}:${minutes} ${dayTime}`;
    // Add local timezone abbreviation
    const tz = date
        .toLocaleTimeString('en-us', { timeZoneName: 'short' })
        .split(' ')
        .pop();
    dateTime += ` (${tz})`;
    return dateTime;
}
